import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {BITCOIN_APP_CONFIG} from "../../config/api";
import {LoaderService} from "../loader.service";
import {BehaviorSubject, Observable} from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class BitcoinAppService {
  private config = BITCOIN_APP_CONFIG;

  iframeVisibility = new BehaviorSubject(null);
  updateBalance = new BehaviorSubject(null);

  constructor(private http: HttpClient,
              public loaderService: LoaderService) {
  }

  getCheckoutUrl(aiStyleId: string, amount: number, aiTypeImageGeneration: string, keywords: string): Observable<any> {
    this.loaderService.show();
    return this.http.post<any>(this.config.getCheckoutUrl, {aiStyleId, amount, aiTypeImageGeneration, keywords});
  }

  getWithdrawUrl(amount) {
    this.loaderService.show();
    return this.http.post<any>(this.config.getWithdrawUrl, {amount});
  }

  isWithdrawCryptoSessionExist() {
    this.loaderService.show();
    return this.http.post<any>(this.config.isWithdrawCryptoSessionExist, {});
  }

  isCheckoutCryptoSessionExist() {
    this.loaderService.show();
    return this.http.post<any>(this.config.isCheckoutCryptoSessionExist, {});
  }

  hideIframe(): void {
    this.iframeVisibility.next({show: false, src: ''});
  }
  showIframe(src: string): void {
    this.iframeVisibility.next({show: true, src: src});
  }

  requestBalanceUpdating(): void {
    this.updateBalance.next(Math.random());
    this.updateBalance.next(null);
  }
}
